import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const AssignStatus = MatxLoadable({
    loader: () =>
        import ("./AssignStatus")
})
const AllAssignStatus = MatxLoadable({
    loader: () =>
        import ("./AllAssignStatus")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const AssignStatusRoutes = [
    {
        path: "/assign_status",
        component: AllAssignStatus,
        // settings
    },

];

export default AssignStatusRoutes;